<template>
    <ProgressBar v-if="loadingHeader" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <Toast />
    <div class="header border-bottom-1 border-200 z-3">
        <div class="flex justify-content-between align-items-center w-full">
            <div class="text-color-secondary text-xl flex align-items-center">
                <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
                <span class="ml-2">Voltar</span>

            </div>

        </div>
    </div>
    <div class="surface-50 pt-8 pb-8">
        <div class="container">
            <div class="mb-3 mt-3 flex flex-column gap-3">
                <div class="flex align-items-center">
                    <AccountGroupOutlineIcon class="text-color-secondary mr-3" />
                    <InputText @keyup="atualizarStatusGrupo" type="text" v-model="grupo.nome"
                        placeholder="Dê um nome para o grupo. Você e os alunos verão esse nome em certos contextos."
                        class="w-full" required />
                </div>

                <div class="flex align-items-center" >
                    <BookEditOutlineIcon class="text-color-secondary mr-3" />
                    <MultiSelect @change="atualizarStatusPlanos" type="text" v-model="grupo.planos" display="chip"
                        :options="planosAula" optionLabel="titulo" optionValue="id"
                        placeholder="Selecione um ou mais planos de aula" class="w-full" required />
                </div>

                <div class="flex align-items-center">
                    <CounterIcon class="text-color-secondary mr-3" />
                    <InputNumber @keyup="atualizarStatusGrupo" v-model="grupo.numeroGrupos"
                        placeholder="Quantidade de grupos" inputId="integeronly" class="w-full" />
                </div>
                <div class="justify-content-between flex flex-column md:flex-row gap-2 " >
                    <div class="w-full">
                        <Dropdown @change="atualizarStatusGrupo" v-model="grupo.quemEscolheu" :options="quemEscolheu"
                            optionLabel="nome" optionValue="valor" placeholder="Quem escolhe" class="w-full"></Dropdown>
                    </div>

                    <div class="w-full">
                        <Dropdown  :disabled="grupo.quemEscolheu == 2"
                            @change="atualizarStatusGrupo" v-model="grupo.metodoCriacao" :options="metodosCriacaoGrupo"
                            optionLabel="nome" optionValue="valor" placeholder="Método de criação" class="w-full">
                        </Dropdown>
                    </div>
                </div>



                <div class="flex flex-column gap-3" v-if="grupo.metodoCriacao == 2">
                    <div v-for="criterio in criterios" :key="criterio.valor" class="flex f align-items-center">
                        <RadioButton v-model="grupo.criterio" :inputId="`criterio${criterio.valor}`" :name="criterio.nome" :value="criterio.valor" />
                        <label :for="`criterio${criterio.valor}`" class="ml-2 text-color">{{ criterio.nome }}</label>
                    </div>
                </div>
                <div v-if="grupo.nome == '' || grupo.planos.length == 0 || grupo.numeroGrupos == 0 || grupo.quemEscolheu == null || grupo.metodoCriacao == null">
                    <div class="text-red-400 mt-2">*Preencha todos os campos para criar os grupos</div>
                </div>

                <div>
                    <Button @click="gerarGrupos()" :label="grupo.grupos.length == 0 ? 'Criar Grupos' : 'Recriar grupos'"
                        class="w-full" outlined :disabled="grupo.nome == '' || grupo.planos.length == 0 || grupo.numeroGrupos == 0 || grupo.quemEscolheu == null || grupo.metodoCriacao == null" />
                </div>
            </div>
        </div>

        <div class="container-fluid" style="max-width: 1200px">
            <div class="grid">
                <div class="col-12 md:col-3" v-for="(grupo, index) in grupo.grupos" :key="index">
                    <div class="bg-white border-1 border-round border-200">
                        <div class="flex justify-content-between">
                            <div class="p-3 pb-2 font-medium">
                                {{ grupo.nome }}
                            </div>
                            <div class="p-3 pb-2 font-medium">{{ grupo.estudantes.length }}</div>

                        </div>
                        <draggable :list="grupo.estudantes" item-key="id" group="estudantes" ghost-class="ghost"
                            @end="onEndDrag">

                            <template #item="{ element }">

                                <div class="p-3 pb-2 flex align-items-center column-gap-2 cursor-pointer hover:surface-100">
                                    <img :src="element.img"
                                        style="min-width:50px; min-height: 50px; max-width:50px; max-height: 50px; border-radius:50%; object-fit: cover;">
                                    <span>
                                        <div class="text-sm font-medium text-color mb-1">{{ element.nome }}</div>
                                    </span>
                                </div>
                            </template>
                        </draggable>
                    </div>
                </div>

            </div>

        </div>
        <div class="container">
            <Button :disabled="grupo.status == 'salvo' || grupo.nome == '' || grupo.planos.length == 0 || grupo.numeroGrupos == 0 || grupo.quemEscolheu == null || grupo.metodoCriacao == null" :loading="btnLoading" v-if="grupo.grupos.length > 0"
                :label="grupo.status == 'novo' ? 'Salvar grupos' : 'Atualizar grupos'" @click="salvarGrupos()"
                class="mt-3 w-full" />
        </div>


    </div>
</template>

<script setup>

import { ref, computed, onMounted } from 'vue'
import { supabase } from '@/supabase'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Button from 'primevue/button';
import MultiSelect from 'primevue/multiselect';
import ToastService from 'primevue/toastservice';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import ProgressBar from 'primevue/progressbar';
import SelectButton from 'primevue/selectbutton';
import RadioButton from 'primevue/radiobutton';
import Dropdown from 'primevue/dropdown';
import { useRouter } from 'vue-router';
import Toast from 'primevue/toast';
import draggable from 'vuedraggable'


import AccountGroupOutlineIcon from 'vue-material-design-icons/AccountGroupOutline.vue'
import BookEditOutlineIcon from 'vue-material-design-icons/BookEditOutline.vue'
import CounterIcon from 'vue-material-design-icons/Counter.vue'

const router = useRouter();
const store = useStore()
const route = useRoute()



const turma = computed(() => store.state.turma)
const loadingHeader = computed(() => store.state.loading)

console.log(turma.value)

onMounted(() => {
    listarEstudantes()
    listarPlanos()
})
const estudantes = ref([])
const planosAula = ref([])



function goBack() {
    router.go(-1);
}

const idGrupo = ref(0)
if (route.query.id != undefined) {
    idGrupo.value = route.query.id
    carregarGrupos()
}

const metodosCriacaoGrupo = ref([{ valor: 1, nome: 'Criação Manual' }, { valor: 2, nome: 'Criação com Assistência' }]);
const quemEscolheu = ref([{ valor: 1, nome: 'Escolha do professor' }, { valor: 2, nome: 'Escolha do Estudante' }])

const grupo = ref({
    nome: '',
    planos: [],
    numeroGrupos: 5,
    metodoCriacao: 2,
    quemEscolheu: 1,
    grupos: [],
    status: 'novo',
    criterio: 1
})
const criterios = ref([
    {nome: 'Grupos heterogêneos (gênero e desempenho)', valor: 1},
    { nome: 'Grupos heterogêneos (desempenho)', valor: 2 },
    { nome: 'Grupos homogêneos (desempenho)', valor: 3 }
])

const grupoStatus = ref('novo')
const planosStatus = ref('novo')
const gruposStatus = ref('novo')

function atualizarStatusGrupo() {
    if (grupoStatus.value == 'salvo') {
        grupo.value.status = 'pendente'
        grupoStatus.value = 'pendente'
    }

}
function atualizarStatusPlanos() {
    if (planosStatus.value === 'salvo') {
        grupo.value.status = 'pendente'
        planosStatus.value = 'pendente'
    }
}
function atualizarStatusGrupos() {
    if (gruposStatus.value == 'salvo') {
        grupo.value.status = 'pendente'
        gruposStatus.value = 'pendente'
    }
}


function onEndDrag() {
    atualizarStatusGrupos()
}

function gerarGrupos() {
    atualizarStatusGrupos()
    if (grupo.value.metodoCriacao == 1) {
        gerarGruposManualmente()
    } else {
        if (grupo.value.criterio == 1) {
            criarGruposHeterogeneosGeneroDesempenho()
        } else if (grupo.value.criterio == 2) {
            criarGruposHeterogeneosDesempenho()
        } else if (grupo.value.criterio == 3) {
            criarGruposHomogeneosDesempenho()
        }
    }
}
function criarGruposHeterogeneosGeneroDesempenho() {
    let alunos = JSON.parse(JSON.stringify(estudantes.value.filter(estudante => estudante.genero == 'M')));
    alunos = embaralharArray(alunos)


    let alunas = JSON.parse(JSON.stringify(estudantes.value.filter(estudante => estudante.genero == 'F')));
    alunas = embaralharArray(alunas)


    const numeroGrupos = grupo.value.numeroGrupos


    let mediaDaTurma = 0
    estudantes.value.forEach(estudante => {
        mediaDaTurma += estudante.media
    })
    mediaDaTurma = mediaDaTurma / estudantes.value.length

    let grupos = Array.from({ length: numeroGrupos }, () => ({
        estudantes: [],
        media: 0,
        notas: []
    }));



    while (alunos.length > 0) {
        let grupoMenor = 0
        for (let i = 0; i < grupos.length; i++) {
            if (grupos[i].estudantes.length < grupos[grupoMenor].estudantes.length) {
                grupoMenor = i
            }
        }

        let g = grupoMenor

        let estudanteEscolhido = null
        let menorDiferenca = 100
        let media = 0
        for (let a = 0; a < alunos.length; a++) {
            let soma = 0
            if (grupos[g].notas.length > 0) {
                soma = grupos[g].notas.reduce((acc, nota) => acc + nota, 0)
            }
            media = (soma + alunos[a].media) / (grupos[g].notas.length + 1)
            let diferenca = Math.abs(media - mediaDaTurma)
            if (diferenca <= menorDiferenca) {
                estudanteEscolhido = alunos[a]
                menorDiferenca = diferenca
            }
        }
        if (estudanteEscolhido) {
            grupos[g].estudantes.push(estudanteEscolhido)
            grupos[g].notas.push(estudanteEscolhido.media)
            grupos[g].media = media

            alunos.splice(alunos.indexOf(estudanteEscolhido), 1)
        }
    }

    while (alunas.length > 0) {

        let grupoMenor = 0
        for (let i = 0; i < grupos.length; i++) {
            if (grupos[i].estudantes.length < grupos[grupoMenor].estudantes.length) {
                grupoMenor = i
            }
        }

        let g = grupoMenor

        let estudanteEscolhido = null
        let menorDiferenca = 100
        let media = 0
        for (let a = 0; a < alunas.length; a++) {
            let soma = 0
            if (grupos[g].notas.length > 0) {
                soma = grupos[g].notas.reduce((acc, nota) => acc + nota, 0)
            }
            media = (soma + alunas[a].media) / (grupos[g].notas.length + 1)
            let diferenca = Math.abs(media - mediaDaTurma)
            if (diferenca <= menorDiferenca) {
                estudanteEscolhido = alunas[a]
                menorDiferenca = diferenca
            }
        }
        if (estudanteEscolhido) {
            grupos[g].estudantes.push(estudanteEscolhido)
            grupos[g].notas.push(estudanteEscolhido.media)
            grupos[g].media = media

            alunas.splice(alunas.indexOf(estudanteEscolhido), 1)
        }
    }


    let gruposReorganizados = []
    for (let g = 0; g < grupos.length; g++) {
        let estudantes = ordenarAlfabeticamente(grupos[g].estudantes)
        gruposReorganizados.push({ numero_grupo: g + 1, estudantes: estudantes, nome: 'Grupo ' + (g + 1) })
    }




    grupo.value.grupos = gruposReorganizados




}

function criarGruposHeterogeneosDesempenho() {
    let alunos = JSON.parse(JSON.stringify(estudantes.value));
    alunos = embaralharArray(alunos)


    const numeroGrupos = grupo.value.numeroGrupos


    let mediaDaTurma = 0
    estudantes.value.forEach(estudante => {
        mediaDaTurma += estudante.media
    })
    mediaDaTurma = mediaDaTurma / estudantes.value.length

    let grupos = Array.from({ length: numeroGrupos }, () => ({
        estudantes: [],
        media: 0,
        notas: []
    }));



    while (alunos.length > 0) {
        let grupoMenor = 0
        for (let i = 0; i < grupos.length; i++) {
            if (grupos[i].estudantes.length < grupos[grupoMenor].estudantes.length) {
                grupoMenor = i
            }
        }

        let g = grupoMenor

        let estudanteEscolhido = null
        let menorDiferenca = 100
        let media = 0
        for (let a = 0; a < alunos.length; a++) {
            let soma = 0
            if (grupos[g].notas.length > 0) {
                soma = grupos[g].notas.reduce((acc, nota) => acc + nota, 0)
            }
            media = (soma + alunos[a].media) / (grupos[g].notas.length + 1)
            let diferenca = Math.abs(media - mediaDaTurma)
            if (diferenca <= menorDiferenca) {
                estudanteEscolhido = alunos[a]
                menorDiferenca = diferenca
            }
        }
        if (estudanteEscolhido) {
            grupos[g].estudantes.push(estudanteEscolhido)
            grupos[g].notas.push(estudanteEscolhido.media)
            grupos[g].media = media

            alunos.splice(alunos.indexOf(estudanteEscolhido), 1)
        }
    }
    let gruposReorganizados = []
    for (let g = 0; g < grupos.length; g++) {
        let estudantes = ordenarAlfabeticamente(grupos[g].estudantes)
        gruposReorganizados.push({ numero_grupo: g + 1, estudantes: estudantes, nome: 'Grupo ' + (g + 1) })
    }

    grupo.value.grupos = gruposReorganizados

}
function criarGruposHomogeneosDesempenho() {
    let alunos = estudantes.value.filter(aluno => aluno.genero == 'M').sort((a, b) => a.media - b.media);
    let alunas = estudantes.value.filter(aluna => aluna.genero == 'F').sort((a, b) => a.media - b.media);

    let estudantesIntercalados = [];
    let indexAluno = 0;
    let indexAluna = 0;

    while (indexAluno < alunos.length || indexAluna < alunas.length) {
        if (indexAluno < alunos.length) {
            estudantesIntercalados.push(alunos[indexAluno++]);
        }
        if (indexAluna < alunas.length) {
            estudantesIntercalados.push(alunas[indexAluna++]);
        }
    }

    const numeroGrupos = grupo.value.numeroGrupos
    let alunosPorGrupo = Math.floor(estudantesIntercalados.length / numeroGrupos)


    let grupos = Array.from({ length: numeroGrupos }, () => ({
        numero_grupo: null, estudantes: [], nome: '', tamanhoGrupo: alunosPorGrupo
    }))

    let totalAlocado = numeroGrupos * alunosPorGrupo
    let i = 0
    while (totalAlocado < estudantesIntercalados.length) {
        grupos[i].tamanhoGrupo = grupos[i].tamanhoGrupo + 1
        totalAlocado++
        if (i < grupos.length) {
            i++
        } else {
            i = 0
        }
    }


    let resto = estudantesIntercalados.length % numeroGrupos


    for (let i = 0; i < grupos.length; i++) {

        grupos[i].numero_grupo = i + 1
        grupos[i].nome = 'Grupo ' + (i + 1)
        grupos[i].estudantes = estudantesIntercalados.splice(0, grupos[i].tamanhoGrupo)
        ordenarAlfabeticamente(grupos[i].estudantes)
    }


    grupo.value.grupos = grupos

}

function embaralharArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

const ordenarAlfabeticamente = (array) => {
    return array.sort((a, b) => a.nome.localeCompare(b.nome));
};

async function carregarGrupos() {
    
    let { data, error } = await supabase
        .from('grupos')
        .select('id, nome, metodo_criacao, quem_escolheu, criterio, grupos_planos(plano), grupos_estudantes(numero_grupo, estudante, users(id, nome, img))')
        .eq('id', idGrupo.value)

    if (data) {
        
        data = data[0]
        let planos = []
        data.grupos_planos.forEach(item => {
            planos.push(item.plano)
        })

        let gruposEstudantes = formatarGrupos(data.grupos_estudantes)
        let numeroGrupos = calcularNumeroGrupos(data.grupos_estudantes)
        let grupoCarregado = {
            nome: data.nome,
            planos: planos,
            numeroGrupos: numeroGrupos,
            metodoCriacao: data.metodo_criacao,
            quemEscolheu: data.quem_escolheu,
            grupos: gruposEstudantes,
            criterio: data.criterio,
            status: 'salvo',
        }

        grupo.value = grupoCarregado
    }

    grupo.value.status = 'salvo'
    grupoStatus.value = 'salvo'
    planosStatus.value = 'salvo'
    gruposStatus.value = 'salvo'




    function formatarGrupos(dadosOriginais) {
        const dadosAgrupados = dadosOriginais.reduce((grupos, item) => {
            if (!grupos[item.numero_grupo]) {
                grupos[item.numero_grupo] = {
                    numero_grupo: item.numero_grupo,
                    nome: 'Grupo ' + item.numero_grupo,
                    estudantes: []
                };
            }
            grupos[item.numero_grupo].estudantes.push({
                id: item.users.id,
                nome: item.users.nome,
                img: item.users.img
            });

            return grupos;
        }, {});


        return Object.values(dadosAgrupados);

    }

    function calcularNumeroGrupos(grupos) {
        let maiorNumero = 0
        grupos.forEach(item => {
            if (item.numero_grupo > maiorNumero) {
                maiorNumero = item.numero_grupo
            }
        })
        return maiorNumero
    }
}

const btnLoading = ref(false)

async function salvarGrupos() {
    if (grupo.value.status == 'pendente') {
        atualizar()
        return
    }
    btnLoading.value = true
    const { data, error } = await supabase
        .from('grupos')
        .insert({ nome: grupo.value.nome, quem_escolheu: grupo.value.quemEscolheu, metodo_criacao: grupo.value.metodoCriacao, idDaAula: turma.value.idDaAula, criterio: grupo.value.criterio })
        .select()

    if (error) {
        btnLoading.value = false
        alert('Ocorreu um erro ao salvar o grupo')
        return
    }

    idGrupo.value = data[0].id

    let planos = []
    grupo.value.planos.forEach(item => {
        planos.push({ plano: item, grupo: idGrupo.value })
    })

    const { data2, error2 } = await supabase
        .from('grupos_planos')
        .insert(planos)

    if (error2) {
        btnLoading.value = false
        alert('Ocorreu um erro ao salvar o grupo')
        return
    }

    let gruposEstudantes = []
    grupo.value.grupos.forEach(item => {
        if (item.estudantes.length > 0) {
            let numero_grupo = item.numero_grupo
            item.estudantes.forEach(estudante => {
                gruposEstudantes.push({ grupo: idGrupo.value, numero_grupo: numero_grupo, estudante: estudante.id })
            })

        }
    })

    const { data3, error3 } = await supabase
        .from('grupos_estudantes')
        .insert(gruposEstudantes)

    if (error3) {
        btnLoading.value = false
        alert('Ocorreu um erro ao salvar o grupo')
        return
    }
    grupo.value.status = 'salvo'
    grupoStatus.value = 'salvo'
    planosStatus.value = 'salvo'
    gruposStatus.value = 'salvo'
    btnLoading.value = false

}

async function atualizar() {

    if (grupoStatus.value == 'pendente') {
        atualizarGrupo()
    }

    if (planosStatus.value == 'pendente') {
        atualizarPlanosGrupos()
    }

    if (gruposStatus.value == 'pendente') {
        atualizarGruposEstudantes()

    }

}
async function atualizarGrupo() {
    btnLoading.value = true
    const { data, error } = await supabase
        .from('grupos')
        .update({ nome: grupo.value.nome, quem_escolheu: grupo.value.quemEscolheu, metodo_criacao: grupo.value.metodoCriacao, criterio: grupo.value.criterio })
        .eq('id', idGrupo.value)
    if (error) {
        alert('Ocorreu um erro ao atualizar o grupo')
    }
    grupo.value.status = 'salvo'
    grupoStatus.value = 'salvo'
    btnLoading.value = false
}

async function atualizarPlanosGrupos() {
    btnLoading.value = true
    const { data, error } = await supabase
        .from('grupos_planos')
        .delete()
        .eq('grupo', idGrupo.value)
    if (error) {
        btnLoading.value = false
        alert('Ocorreu um erro ao atualizar o grupo')
        return
    }

    let planos = []
    grupo.value.planos.forEach(item => {
        planos.push({ plano: item, grupo: idGrupo.value })
    })

    const { data2, error2 } = await supabase
        .from('grupos_planos')
        .insert(planos)

    if (error2) {
        alert('Ocorreu um erro ao atualizar o grupo')
    }
    btnLoading.value = false
    grupo.value.status = 'salvo'
    planosStatus.value = 'salvo'
}

async function atualizarGruposEstudantes() {
    console.log(grupo.value)
    btnLoading.value = true
    const { data, error } = await supabase
        .from('grupos_estudantes')
        .delete()
        .eq('grupo', idGrupo.value)
    if (error) {
        btnLoading.value = false
        alert('Ocorreu um erro ao atualizar o grupo')
        return
    }

    let gruposEstudantes = []
    grupo.value.grupos.forEach(item => {
        if (item.estudantes.length > 0) {
            let numero_grupo = item.numero_grupo
            item.estudantes.forEach(estudante => {
                gruposEstudantes.push({ grupo: idGrupo.value, numero_grupo: numero_grupo, estudante: estudante.id })
            })

        }
    })

    const { data3, error3 } = await supabase
        .from('grupos_estudantes')
        .insert(gruposEstudantes)

    if (error3) {
        btnLoading.value = false
        alert('Ocorreu um erro ao salvar o grupo')
        return
    }
    grupo.value.status = 'salvo'
    gruposStatus.value = 'salvo'
    btnLoading.value = false



    btnLoading.value = false

}

// Funções concluídas
function gerarGruposManualmente() {
    grupo.value.grupos = []
    for (let i = 1; i <= grupo.value.numeroGrupos; i++) {

        if (i === 1) {
            grupo.value.grupos.push({
                numero_grupo: i,
                nome: 'Grupo ' + i,
                estudantes: estudantes.value
            })
        } else {
            grupo.value.grupos.push({
                numero_grupo: i,
                nome: 'Grupo ' + i,
                estudantes: []
            })
        }

    }
}
async function listarEstudantes() {
    store.dispatch("updateLoading", true)
    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select(`users(id, nome, img, genero)`)
        .eq('idDaTurma', turma.value.idDaTurma)
        .order('nome', { foreignTable: 'users', ascending: true });

    if (error) {
        store.dispatch("updateLoading", false)
        alert('Ocorreu um erro. Recarregue a página e tente novamente.')
    }
    let alunos = []
    data.forEach(aluno => {
        alunos.push({ id: aluno.users.id, nome: aluno.users.nome, img: aluno.users.img, genero: aluno.users.genero, media: 0 })
    })

    estudantes.value = alunos

    // Fetch the last three 'planos' where 'aula' in 'planos_aulas' equals 'turma.value.idDaAula'
    const { data: planosData, error: planosError } = await supabase
        .from('planos_aulas')
        .select('planos(id, planos_avaliacoes(id, tipo, planos_notas(estudante,nota)))')
        .eq('aula', turma.value.idDaAula)
        .in('planos.planos_avaliacoes.tipo', [1, 2])
        .limit(5)
        .order('created_at', { ascending: false });

    if (planosError) {
        store.dispatch("updateLoading", false);
        return;
    }

    // Process and store the fetched plans
    let notas = planosData.map(planoAula => planoAula.planos);

    const somaNotas = {};
    // Percorrer o array de notas para acumular as notas e contagens
    notas.forEach(notaObj => {
        notaObj.planos_avaliacoes.forEach(avaliacao => {
            avaliacao.planos_notas.forEach(nota => {
                if (nota.nota > 0 && nota.nota < 200) { // Considera apenas notas maiores que 0 e menores que 200
                    if (!somaNotas[nota.estudante]) {
                        somaNotas[nota.estudante] = { soma: 0, contagem: 0 };
                    }
                    somaNotas[nota.estudante].soma += nota.nota;
                    somaNotas[nota.estudante].contagem += 1;
                }
            });
        });
    });


    estudantes.value.forEach(estudante => {
        if (somaNotas[estudante.id] && somaNotas[estudante.id].contagem > 0) {
            let media = Math.round(somaNotas[estudante.id].soma / somaNotas[estudante.id].contagem);
            estudante.media = media
        } else {
            estudante.media = 0;
        }
    });
    store.dispatch("updateLoading", false)

}

async function listarPlanos() {
    store.dispatch("updateLoading", true)
    const { data, error } = await supabase
        .from('planos_aulas')
        .select('planos(id, titulo)')
        .eq('aula', turma.value.idDaAula)
        .order('id', { ascending: false })

    if (error) {
        store.dispatch("updateLoading", false)
        alert('Ocorreu um erro. Recarregue a página e tente novamente.')
    }

    let planos = []

    data.forEach(item => {
        planos.push({ id: item.planos.id, titulo: item.planos.titulo })
    })
    planosAula.value = planos

    store.dispatch("updateLoading", false)
}
</script>